import { MultiSelectOption } from "@/components/MultiSelect.vue";

export class Agency implements MultiSelectOption {
  date?: string;
  id!: number;
  name!: string;
}

export default class MultiSelectBroadcaster implements MultiSelectOption {
  id?: number;
  name!: string;
  group?: number;

  agencies?: Set<Agency>;
  advertising_agency?: Agency;

  starts_at?: string | undefined;
  ends_at?: string | undefined;

  ids?: Set<number>;
}
